import { Navigate, Outlet, Route, Routes } from 'react-router-dom'
import { AssistantRuntimeProvider } from '@assistant-ui/react'
import BudgetBanner from '@/components/BudgetBanner'
import ChatThread from '@/components/ChatThread'
import ChatThreadList from '@/components/ChatThreadList'
import RequireAuth from '@/components/RequireAuth'
import RequireSuperAdmin from '@/components/RequireSuperAdmin'
import { BudgetWarningProvider } from '@/contexts/BudgetWarningContext'
import { SidebarProvider, useSidebar } from '@/contexts/SidebarContext'
import Login from '@/pages/Login'
import Settings from '@/pages/Settings'
import { useChatAssistantRuntime } from '@/runtime/useChatAssistantRuntime'
import { ThreadSelectionPersistence } from '@/runtime/ThreadSelectionPersistence'

function AuthenticatedApp() {
  return (
    <SidebarProvider>
      <BudgetWarningProvider>
        <AuthenticatedShell />
      </BudgetWarningProvider>
    </SidebarProvider>
  )
}

function AuthenticatedShell() {
  const runtime = useChatAssistantRuntime()
  const { collapsed, toggleCollapsed } = useSidebar()

  return (
    <AssistantRuntimeProvider runtime={runtime}>
      <ThreadSelectionPersistence />
      <div className="flex h-full min-h-0 overflow-hidden">
        <div
          className={`hidden shrink-0 transition-all duration-300 lg:block ${
            collapsed ? 'w-16' : 'w-72'
          }`}
        >
          <ChatThreadList
            collapsed={collapsed}
            onToggleCollapse={toggleCollapsed}
          />
        </div>

        <main className="flex min-h-0 min-w-0 flex-1 flex-col overflow-hidden bg-gray-50">
          <BudgetBanner />
          <div className="flex min-h-0 flex-1 flex-col overflow-hidden">
            <Outlet />
          </div>
        </main>
      </div>
    </AssistantRuntimeProvider>
  )
}

export default function App() {
  return (
    <Routes>
      <Route path="/login" element={<Login />} />
      <Route
        element={
          <RequireAuth>
            <AuthenticatedApp />
          </RequireAuth>
        }
      >
        <Route path="/" element={<ChatThread />} />
        <Route
          path="/settings"
          element={
            <RequireSuperAdmin>
              <Settings />
            </RequireSuperAdmin>
          }
        />
        <Route path="*" element={<Navigate to="/" replace />} />
      </Route>
    </Routes>
  )
}
